import CloseIcon from '@mui/icons-material/CloseOutlined';
import { Box, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useDialogContext } from 'pages/ParentHelper/providers/DialogProvider/hooks';

export const Header = () => {
  const { onClose } = useDialogContext();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Typography variant="h5">
        {t('pages.parentHelper.history.header.title')}
      </Typography>
      <IconButton onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </Box>
  );
};
